<template>
  <div>
    <!-- 邮件接收设置 -->
    <baseBreadcrumb :page="$t('message.emailBlockConfig')" :menu="$t('message.userInfo')"></baseBreadcrumb>
    <div class="body">
      <div class="table">
        <ol>
          <li></li>
          <!-- 邮件内容 -->
          <li class="flex3">{{ $t('message.mailContent') }}</li>
          <li>最終更新日付</li>
          <!-- 是否开启 -->
          <li>{{ $t('message.isEnabled') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li>{{ item.node }}</li>
          <!-- 邮件内容 -->
          <li class="flex3">{{ item.content }}</li>
          <li>{{ item.updated_at }}</li>
          <!-- 是否开启 -->
          <li>
            <div>
              <el-radio v-model="item.is_open" :label="1" disabled>开启</el-radio>
              <el-radio v-model="item.is_open" :label="0" disabled>关闭</el-radio>
              <p v-if="item.childs">
                <el-select v-model="item.childs.upstorage_complete_type.value" disabled style="width: 140px;">
                  <el-option :label="items.label" :value="items.value"
                    v-for="items in item.childs.upstorage_complete_type.options" :key="items.value">
                  </el-option>
                </el-select>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.emailBlockConfig()
  },
  methods: {
    emailBlockConfig() {
      this.$api.clienteleApi.emailBlockConfig({ user_id: this.$route.query.userID, }).then(res => {
        res.data.forEach(item => {
          item.is_open = item.is_open ? 1 : 0
        })
        this.tableData = res.data
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  ol {
    height: 50px;
  }


  ul {
    padding: 20px 0;
    background-color: #fff;
  }

  .flex3 {
    flex: 3;
  }

  /deep/.is-checked {
    .el-radio__label {
      color: #B4272D !important;
    }

    .el-radio__inner {
      background-color: #B4272D;
      border-color: #B4272D;
    }

  }




}
</style>